import { Badge, SkeletonBox } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { billStatusToBadgeColor } from '@features/bills/constants/billStatusToBadgeVariant'
import { billStatusToTitleKey } from '@features/bills/constants/billStatusToTitleKey'
import { useGetBill } from '@features/bills/hooks/useGetBill'
import { getBillStatus } from '@features/bills/utils/getBillStatus'

import { useBillForm } from '../../contexts/billFormContext'
import * as Styled from './styles'

export const BillStatusBadge = (): ReactElement | null => {
  const { billId } = useBillForm()
  const { data: billData, isLoading: isBillLoading } = useGetBill(billId)
  const { t } = useTranslation()

  if (!billId || (!billData && !isBillLoading)) {
    return null
  }

  const { bill } = billData || {}
  const { amount, balance, dueDate, isPaid, state, tax } = bill || {}

  const billStatus = getBillStatus({
    amount,
    balance,
    dueDate: dueDate ? new Date(dueDate) : undefined,
    isPaid,
    state,
    tax,
  })

  const badgeColor = billStatusToBadgeColor[billStatus]
  const badgeLabel = t(billStatusToTitleKey[billStatus])

  return (
    <Styled.BillStatusBadgeWrapper>
      {isBillLoading ? (
        <SkeletonBox height={20} width={55} />
      ) : (
        <Badge color={badgeColor} mode="subtle">
          {badgeLabel}
        </Badge>
      )}
    </Styled.BillStatusBadgeWrapper>
  )
}
